var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBattery = function SvgBattery(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Battery",
    viewBox: "0 0 14 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0317897,8 L1.86168424,8 C1.01914607,8 0.333333333,7.3424 0.333333333,6.53333333 L0.333333333,1.46666667 C0.333333333,0.6576 1.01914607,0 1.86168424,0 L11.0317897,0 C11.8743279,0 12.5601406,0.6576 12.5601406,1.46666667 L12.5601406,1.6 L12.6940797,1.6 C13.230392,1.6 13.6666667,2.01866667 13.6666667,2.53333333 L13.6666667,5.46666667 C13.6666667,5.98133333 13.230392,6.4 12.6940797,6.4 L12.5601406,6.4 L12.5601406,6.53333333 C12.5601406,7.3424 11.8743279,8 11.0317897,8 Z M1.86168424,0.8 C1.47876287,0.8 1.16697928,1.0992 1.16697928,1.46666667 L1.16697928,6.53333333 C1.16697928,6.9008 1.47876287,7.2 1.86168424,7.2 L11.0317897,7.2 C11.4147111,7.2 11.7264947,6.9008 11.7264947,6.53333333 L11.7264947,6 C11.7264947,5.7792 11.9132314,5.6 12.1433176,5.6 L12.6940797,5.6 C12.7707752,5.6 12.8330207,5.54026667 12.8330207,5.46666667 L12.8330207,2.53333333 C12.8330207,2.45973333 12.7707752,2.4 12.6940797,2.4 L12.1433176,2.4 C11.9132314,2.4 11.7264947,2.2208 11.7264947,2 L11.7264947,1.46666667 C11.7264947,1.0992 11.4147111,0.8 11.0317897,0.8 L1.86168424,0.8 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("g", {
    id: "indicators",
    transform: "translate(2.333333, 2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "__low",
    x: 0,
    y: 0,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "__med",
    x: 3.33333333,
    y: 0,
    width: 2,
    height: 4
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBattery);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "battery.310929380b11af4cd9b0cf4c588c1c26.svg";